import { useState } from "react";
// import validator from 'validator'
import moment from "moment";

const useForm = () => {
  const [state, setState] = useState({});
  const [date, setDate] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [visible, setVisible] = useState(false);

  // const [value, setValue] = useState('')

  const onChangeHandler = (e) => {
    const value = e.value;
    const name = e.name;
    setState({
      ...state,
      [name]: value,
    });
  };

  const onChangeTextHandler = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleOpenCloseDrawer = () => {
    setVisible(!visible);
  };

  const onChangeSelectedRow = () => {
    setSelectedRows({
      ...selectedRows,
    });
  };
  const onChangeCheckbox = (e) => {
    const value = e.target.checked;
    const name = e.target.name;
    const upperCaseValue = value.toUpperCase();
    setState({
      ...state,
      [name]: upperCaseValue,
    });
  };

  const onChangeDatePicker = (date, dateString, fieldName) => {
    const name = fieldName;
    var momentString = date.format("YYYY");
    setState({
      ...state,
      [name]: momentString,
    });
  };

  const onChangeDropdown = (value, title) => {
    const { label, key } = value;

    setState({
      ...state,
      [title]: [
        {
          label: label,
          value: key,
        },
      ],
    });
  };
  const onRangePickerHandler = (value) => {
    const newArray = [];

    // const { name, value } = e.target;
    // value &&
    value?.map((item) => {
      return newArray.push(item._d.valueOf());
    });

    setDate({
      ...date,
      date: newArray,
    });
  };

  return {
    date,
    state,
    onChangeSelectedRow,
    onChangeHandler,
    onChangeTextHandler,
    handleOpenCloseDrawer,
    onChangeDropdown,
    onChangeCheckbox,
    onRangePickerHandler,
    onChangeDatePicker,
    setState,
  };
};

export default useForm;
